const HttpBackend = require('i18next-http-backend/cjs');
const ChainedBackend = require('i18next-chained-backend').default;
const LocalStorageBackend = require('i18next-localstorage-backend').default;

module.exports = {
  backend: {
    backendOptions: [{ expirationTime: 60 * 60 * 1000 }, { loadPath: '/docs/api/locales/{{lng}}/{{ns}}' }],
    backends: typeof window !== 'undefined' ? [LocalStorageBackend, HttpBackend] : [],
  },
  // debug: true,
  i18n: {
    defaultLocale: 'en-US',
    locales: ['en-US', 'ko', 'ja', 'zh-Hans'],
  },
  serializeConfig: true,
  partialBundledLanguages: true,
  use: typeof window !== 'undefined' ? [ChainedBackend] : [],
};
